import React, { ReactNode } from 'react';
import Link from 'next/link';
import { NewsData } from '@wwe-portal/entities/news.type';

type NewsLinkProps = React.PropsWithChildren<{
  item: NewsData;
  className?: string;
}>;

export const NewsPostLink = ({ item, children, className }: NewsLinkProps) => {
  return (
    <Link className={className} href={`/news/post/${item.slug || item.id}`}>
      {children}
    </Link>
  );
};

export const NewsCategoryLink = ({
  category,
  className,
  children,
}: {
  category: string;
  className?: string;
  children: ReactNode;
}) => {
  return (
    <Link className={className} href={`/news/category/${category}`}>
      {children}
    </Link>
  );
};
